import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";


import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import InputGroup from "./../../elements/InputGroup";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";

const CustomTemplateModal = ({
  setCreateCustomTemplateModal,
  defaultLibraryList,
  createCustTemplate
  // applyFiltersHandler,
}) => {
  const [assigneeId, setAssigneeId] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [parentLibraries, setParentLibraries] = useState([]);
  const [selParentLibId, setSelParentLibId] = useState(null);
  const [custTemplateName, setCustTemplateName] = useState(null);
  const [custTemplateDesc, setCustTemplateDesc] = useState(null);

  const [templateName, setTemplateName] = useState("");
  const [createdBy, setCreatedBy] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [status, setStatus] = useState(null);
  const animatedComponents = makeAnimated();

  useEffect(()=>{
    defaultLibraryList.forEach((obj)=>{
      setParentLibraries((prev)=>[...prev,{label:obj.name,value:obj._id}])
    })
  },[])
  const handleCreateCustTemplate = () => {
    const payload = {
        parentTemplateID: selParentLibId ,
        name: custTemplateName ,
        description: custTemplateDesc 
    };
    createCustTemplate(payload);
  };

  return (
    <Modal
      width={"35%"}
      minHeight={"350px"}
      title="Create Custom Template"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          <CloseIcon
            style= {{ cursor: "pointer" }}
            onClick={() => {
              setCreateCustomTemplateModal(false);
            }}
          />
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setCreateCustomTemplateModal(false);
            }}
            label="Cancel"
          />
          <span>
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Create Template"
              onClick={() => {
                handleCreateCustTemplate();
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <Dropdown
          label="Select Parent Template"
          options={parentLibraries}
          onSelect={(e) => {setSelParentLibId(e.value)}}
          placeHolder={"Select Template"}
        />

        <InputGroup
          class_="mb-3 mt-3"
          label="Template Name"
          inputs={[
            <>
              <input
                name="tag"
                value={custTemplateName}
                onChange={(e) => {
                  setCustTemplateName(e.target.value);
                }}
                placeholder="Template Name"
              />
            </>,
          ]}
        />

        <InputGroup
          class_="mb-3 mt-2"
          label="Template Description"
          inputs={[
            <>
              <textarea
                name="Template Description"
                
                placeholder="Template Description"
                value={custTemplateDesc}
                onChange={(e) => {
                  setCustTemplateDesc(e.target.value);
                }}
              />
            </>,
          ]}
        />
      </div>
    </Modal>
  );
};

export default CustomTemplateModal;
